import { Agent, AgentPermission } from "~/services/agents";

// Duplicating an agent maps to the `can_duplicate` grant, resolved per-agent by
// the API. Every caller who can see the agent holds it — editors and USER-level
// grants included, and SYSTEM agents confer it on everyone. Distinct from
// deleting (`can_delete`), which only managers hold.
export const useCanDuplicateAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.permissions.includes(AgentPermission.CAN_DUPLICATE);
